module.exports = __webpack_public_path__ + "img/undraw_medicine_b-1-ol.c5aa3c2d.svg";